export const VEHICLE_TYPE_TO_CATEGORY_MAP = {
  1: 'car',
  2: 'utility',
  3: 'motorcycle',
  4: 'caravan',
}
